<template>
<div class="maincont">
  <div class="ef--inner">
    <ul class="send-mail-tab">
      <li class="send-mail-tab-item" v-on:click="changeTab('0')" v-bind:class="{'active': dispTab == '0'}"><span class="bt">お知らせ一斉メール手動送信</span></li>
      <li class="send-mail-tab-item" v-on:click="changeTab('1')" v-bind:class="{'active': dispTab == '1'}"><span class="bt">自動配信メール設定</span></li>
    </ul>
    <div class="send-mail-content">
      <div class="send-mail-content-item" v-if="dispTab == '0'">
        <ul class="top-button">
          <li class="top-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onHighTemp">テンプレート挿入(高温注意報)</a></li>
          <li class="top-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onLowTemp">テンプレート挿入(低温注意報)</a></li>
        </ul>
        <ul class="mail-form">
          <li class="mail-form-item">
            <div class="mail-form-caption"><label>件名</label></div>
            <div class="mail-form-input">
              <input type="text" class="input-field" name="subject" data-vv-as="件名" v-model="inputSubject" v-validate="'max:32'">
              <div class="err_message">
                {{ errors.first("subject") }}
              </div>
            </div>
          </li>
          <li class="mail-form-item">
            <div class="mail-form-caption"><label>本文</label></div>
            <div class="mail-form-input">
              <textarea rows="5" class="input-field" name="text" data-vv-as="本文" v-model="inputText" v-validate="'max:500'"></textarea>
              <div class="err_message">
                {{ errors.first("text") }}
              </div>
            </div>
          </li>
        </ul>
        <div class="file">
          <h4 class="file-caption">メール挿入画像</h4>
          <div class="file-data">
            <div class="file-name">画像：{{ inputFileName }}</div>
            <div class="file-button"><a href="javascript:void(0);" class="bt-gray" @click="deleteFile">削除</a></div>
          </div>
          <div class="file-drop-box" @dragover.prevent @drop.prevent="dropFile">ここにファイルをドロップ</div>
        </div>
        <ul class="bottom-button">
          <li class="bottom-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onSave">保存</a></li>
          <li class="bottom-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onSend">送信</a></li>
        </ul>
      </div>
      <div class="send-mail-content-item" v-if="dispTab == '1'">
        <div class="auto-setting">
          <h4 class="auto-setting-caption">自動配信設定</h4>
          <div class="auto-setting-form"><label class="checkbox"><input type="checkbox" v-model="autoSend">翌日のでんき予報が「厳しい」場合、前日の17:00に一斉メールを自動配信</label></div>
        </div>
        <ul class="bottom-button">
          <li class="bottom-button-item"><a href="javascript:void(0);" class="bt-gray" @click="onCancel">キャンセル</a></li>
          <li class="bottom-button-item"><a href="javascript:void(0);" class="bt-cyan" @click="onSave">設定</a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Store from "../../store";

export default {
  name: "send-mail",
  data: function() {
    return {
      dispTab: 0,
      inputSubject: "",
      inputText: "",
      inputFileName: "",
      inputFileBase64: "",
      files: [],
      autoSend: false
    };
  },
  created: function() {
    console.log("created");

    this.getNoticeMail();
    this.getAutoMail();
  },
  methods: {
    changeTab: function(num) {
      console.log("changeTab");
      this.dispTab = num;
    },
    dropFile: async function() {
      console.log("dropFile");
      this.files = [...event.dataTransfer.files];
      if (this.files.length != 0) {
        const fileInfo = this.files[0];
        console.log(fileInfo);
        const picture = await this.getBase64(fileInfo);
        if (picture.slice(0, 10) == "data:image") {
          this.inputFileName = fileInfo.name;
          this.inputFileBase64 = picture;
        }
      }
    },
    deleteFile: function () {
      console.log("deleteFile");
      this.inputFileName = "";
      this.inputFileBase64 = "";
    },
    getBase64: function(file) {
      console.log("getBase64");
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    },
    getNoticeMail: function() {
      console.log("getNoticeMail");

      // お知らせメール設定を取得する
      this.$axios
        .get(`/srv/api/notice_mail_data/${Store.state.parentID}`, {
          withCredentials: true
        })
        .then(response => {
          console.log("notice_mail_data success");
          console.log(response.data);
          if (typeof response.data == "object") {
            this.inputSubject = response.data.title;
            this.inputText = response.data.message;
            this.inputFileName = response.data.image_name;
            this.inputFileBase64 = response.data.image_data;
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log("notice_mail_data error");
          console.log(error);
        });
    },
    getAutoMail: function() {
      console.log("getAutoMail");

      // 自動配信設定を取得する
      this.$axios
        .get(`/srv/api/auto_mail_data/${Store.state.parentID}`, {
          withCredentials: true
        })
        .then(response => {
          console.log("auto_mail_data success");
          console.log(response.data);
          if (typeof response.data == "object") {
            this.autoSend = response.data.delivery_settings;
          } else {
            // stinrgのときはセッションタイムアウト
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log("auto_mail_data error");
          console.log(error);
        });
    },
    onHighTemp: function() {
      console.log("onHighTemp");
      this.inputSubject = "電衛門からのお知らせ";
      this.inputText = `本日は高温が予測されます。
デマンドが目標値を超過する恐れがあるので、気を付けてください。

※このメールは送信専用メールアドレスから配信されています。
ご返信いただいても内容の確認及び回答ができませんのでご了承ください。
https://denemon.qnext.kyuden.co.jp/`;
    },
    onLowTemp: function() {
      console.log("onLowTemp");
      this.inputSubject = "電衛門からのお知らせ";
      this.inputText = `本日は低温が予測されます。
デマンドが目標値を超過する恐れがあるので、気を付けてください。

※このメールは送信専用メールアドレスから配信されています。
ご返信いただいても内容の確認及び回答ができませんのでご了承ください。
https://denemon.qnext.kyuden.co.jp/`;
    },
    onSend: function() {
      console.log("onSend");
      if (this.inputSubject.length == 0  || this.inputText.length == 0) {
        alert("件名、本文を入力してください。");
        return;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          // 送信確認
          const ans = confirm('メールを送信しますか？');
          if (ans) {
            // 送信処理
            const param = {
              title: this.inputSubject,
              message: this.inputText,
              image_name: this.inputFileName,
              image_data: this.inputFileBase64
            };
            this.$axios
              .put(`/srv/api/notice_mail_send/${Store.state.parentID}`, param, {
                withCredentials: true
              })
              .then(response => {
                console.log(response.data);
                if (response.data.status == "failure") {
                  console.warn("notice_mail_send failure");
                  alert("登録できませんでした。");
                } else {
                  console.log("OK");
                }
              })
              .catch(error => {
                console.log(error);
                alert("登録できませんでした");
              });
          }
        } else {
          alert("エラー内容を確認してください。");
        }
      });

    },
    onSave: function() {
      console.log("onSave");
      if (this.dispTab == 0) {
        // お知らせメール手動送信で保存ボタン押下時
        const ans = confirm('保存しますか？');
        if (ans) {
          this.$validator.validateAll().then(result => {
            if (result) {
              const param = {
                title: this.inputSubject,
                message: this.inputText,
                image_name: this.inputFileName,
                image_data: this.inputFileBase64
              };
              this.$axios
                .put(`/srv/api/notice_mail_data/${Store.state.parentID}`, param, {
                  withCredentials: true
                })
                .then(response => {
                  console.log(response.data);
                  if (response.data.status == "failure") {
                    console.warn("notice_mail_data failure");
                    alert("登録できませんでした。");
                  } else {
                    console.log("OK");
                  }
                })
                .catch(error => {
                  console.log(error);
                  alert("登録できませんでした");
                });
            } else {
              alert("エラー内容を確認してください。");
            }
          });
        }
      } else if (this.dispTab == 1) {
        // 自動配信メールで設定ボタン押下時
        const ans = confirm('設定を変更しますか？');
        if (ans) {
          const param = {
            delivery_settings: this.autoSend
          };
          this.$axios
            .put(`/srv/api/auto_mail_data/${Store.state.parentID}`, param, {
              withCredentials: true
            })
            .then(response => {
              console.log(response.data);
              if (response.data.status == "failure") {
                console.warn("auto_mail_data failure");
                alert("登録できませんでした。");
              } else {
                console.log("OK");
              }
            })
            .catch(error => {
              console.log(error);
              alert("登録できませんでした");
            });
        }
      }
    },
    onCancel: function() {
      console.log("onCancel");
      this.getAutoMail();
    }
  }
}
</script>